export const ProductCard = (target: HTMLDivElement) => {
  const productId = target?.dataset.id

  const el = {
    variants: target.querySelectorAll<HTMLButtonElement>('.product-card__color-dot'),
    variantForm: target.querySelector<HTMLFormElement>('.product-card__form'),
  }

  const method = {
    init: () => {
      method.initVariants(el.variants)
    },

    initVariants: (variants) => {
      variants?.forEach((item) => {
        item.addEventListener('click', (e) => {
          e.preventDefault()

          if (!(e.target instanceof HTMLButtonElement)) {
            return
          }

          const variantSku = e.target.dataset.variant
          method.getNewVariant(variantSku)
        })
      })
    },
    getData(form) {
      const formData = new FormData(form)
      const jsonObject = {}
      formData.forEach((value, key) => (jsonObject[key] = value))
      return JSON.stringify(jsonObject)
    },
    getNewVariant: async (variantSku) => {
      if (!productId || !variantSku) return
      el.variantForm.querySelector<HTMLInputElement>('input[name=variantSku]').value =
        variantSku

      const url = el.variantForm.getAttribute('action')

      fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json;charset=UTF-8',
        },
        body: method.getData(el.variantForm),
      })
        .then((response) => {
          return response.text().then((data) => {
            if (data) {
              target.innerHTML = data
              const newVariants = target.querySelectorAll<HTMLLIElement>(
                '.product-card__color-dot'
              )
              method.initVariants(newVariants)
            }
          })
        })
        .catch((error) => {
          return error
        })
    },
  }

  method.init()
}
